export default __webpack_public_path__ + "static/media/logo.dedbc991.png";